import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { TextV2 } from '@insights-ltd/design-library/components';
import { styled } from '@mui/material';

type VARIANT = 'save' | 'remove';

type BottomBarProps = {
  stringCount: number;
  onProceed: () => void;
  onCancel: () => void;
  variant?: VARIANT;
  disabled?: boolean;
};

const variantData: {
  [key in VARIANT]: {
    buttonProps: { color: any };
    cancelText: string;
    proceedText: string;
  };
} = {
  save: {
    buttonProps: { color: 'primary' },
    cancelText: 'Clear',
    proceedText: 'Save Selection',
  },
  remove: {
    buttonProps: { color: 'error' },
    cancelText: 'Cancel',
    proceedText: 'Remove Selection',
  },
};

const StyledText = styled(TextV2)(({ theme }) => ({
  color: theme.palette.blue.light,
}));

const BottomBar = ({
  stringCount,
  onProceed,
  onCancel,
  variant = 'save',
  disabled = false,
}: BottomBarProps) => {
  const variantProps = variantData[variant];
  return (
    <AppBar
      position="fixed"
      sx={(theme) => ({
        top: 'auto',
        bottom: '0',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: theme.palette.background.paper,
      })}
    >
      <Toolbar
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          width: '85%',
        }}
      >
        <StyledText variant="body1">{stringCount} strings selected.</StyledText>
        <Box>
          <Button
            variant="outlined"
            color="primary"
            onClick={onCancel}
            aria-label="Bottom bar cancel"
          >
            {variantProps.cancelText}
          </Button>
          <Button
            sx={(theme) => ({ marginLeft: theme.spacing(2) })}
            onClick={onProceed}
            variant="contained"
            disabled={disabled}
            {...variantProps.buttonProps}
          >
            {variantProps.proceedText}
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default BottomBar;
